export const parseBoolean = (bool: string) => {
  if (bool) {
    return JSON.parse(bool?.toLowerCase());
  } else return false;
};
